angular.module('CarsSaraBo').factory('ReviewsService', ['$resource', '$http', '$window', function ($resource, $http, $window) {

    var evaluationClass = {
        BAD: {background: 'score-color-0', font: 'font-score-color-0', leftBorder: 'left-border-score-color-0', colorBar: 'score-color-bar-0'},
        REGULAR: {background: 'score-color-30', font: 'font-score-color-30', leftBorder: 'left-border-score-color-30', colorBar: 'score-color-bar-30'},
        GOOD: {background: 'score-color-50', font: 'font-score-color-50', leftBorder: 'left-border-score-color-50', colorBar: 'score-color-bar-50'},
        VERY_GOOD: {background: 'score-color-70', font: 'font-score-color-70', leftBorder: 'left-border-score-color-70', colorBar: 'score-color-bar-70'},
        EXCELLENT: {background: 'score-color-90', font: 'font-score-color-90', leftBorder: 'left-border-score-color-90', colorBar: 'score-color-bar-90'}
    };

    return {
        resource: $resource('../rest/company/:companyOid/review',
            {companyOid: '@companyOid'},
            {
                get: {method: 'GET'}
            }),
        resourceSummary: $resource('../rest/company/:companyOid/review/summary'),
        resourceDestinations: $resource('../rest/company/:companyOid/city-destinations',
            {companyOid: '@companyOid'},
            {
                get: {method: 'GET', isArray: true}
            }),
        resourceReviewScores: $resource('../rest/company/:companyOid/review/review-scores',
            {companyOid: '@companyOid'},
            {
                get: {method: 'GET', isArray: true}
            }),
        resourceReviewSortingCriteria: $resource('../rest/company/:companyOid/review/sorting-criteria',
            {companyOid: '@companyOid'},
            {
                get: {method: 'GET', isArray: true}
            }),
        resourceReviewResponse: $resource('../rest/company/:companyOid/review/response',
            {companyOid: '@companyOid'},
            {
                post: {method: 'POST'}
            }),

        sendReviewResponse: function (company, comment, publish, reviewOid){

            document.getElementById("btnSendResponse_" + reviewOid).className += " -loading";
            document.getElementById("btnSendResponse_" + reviewOid).setAttribute("disabled","disabled");

            // prepare request body
            var requestBody = {
                reviewOid: reviewOid,
                publish: publish,
                comment: comment
            };
            return this.resourceReviewResponse.post({companyOid: company}, requestBody).$promise;
        },

        fetchPage: function (company, page, filter) {
            var params = {companyOid: company};
            angular.extend(params, page, filter);
            return this.resource.get(params).$promise;
        },

        fetchSummary: function (companyOid, destinationOid) {
            return this.resourceSummary.get({companyOid: companyOid, destinationOid: destinationOid}).$promise;
        },

        fetchByFilter: function (filter, page, offset) {
            var params = {pageNumber: page, itemsPerPage: offset};
            angular.extend(params, filter);
            return this.resourceFilter.get(params).$promise;
        },

        fetchDestinations: function (companyOid) {
            return this.resourceDestinations.get({companyOid: companyOid}).$promise;
        },

        fetchScores: function (companyOid) {
            return this.resourceReviewScores.get({companyOid: companyOid}).$promise;
        },

        fetchSortingCriteria: function (companyOid) {
            return this.resourceReviewSortingCriteria.get({companyOid: companyOid}).$promise;
        },

        getEvaluationClass: function (evaluation) {
            return evaluationClass[evaluation];
        },

        getScoreClass: function (score) {
            if (score) {
                score = (score).toFixed(1);
                if (score >= 6) {
                    if (score >= 7) {
                        if (score >= 9) {
                            return evaluationClass["EXCELLENT"];
                        } else {
                            return evaluationClass["VERY_GOOD"];
                        }
                    } else {
                        return evaluationClass["GOOD"];
                    }
                } else {
                    if (score >= 5) {
                        return evaluationClass["REGULAR"];
                    } else {
                        return evaluationClass["BAD"];
                    }
                }
            }
        },

        exportToExcel: function (companyOid, filter) {
            var params = angular.copy(filter);
            var config = {
                data: "",
                headers: {
                    "Content-Type": "application/vnd.ms-excel;charset=UTF-8"
                },
                params: params,
                responseType: "arraybuffer"
            };
            var url = "../rest/company/" + companyOid + "/review";
            return $http.get(url, config).then(function (response) {
                var file = new Blob([response.data], {type: "application/vnd.ms-excel"});
                var fileURL = URL.createObjectURL(file);
                /*
                * this is tricky but it's the way to download files via ajax
                * */
                var a = document.createElement('a');
                a.style = "display: none";
                a.href = fileURL;
                a.target = '_blank';
                a.download = 'reviews.xls';
                document.body.appendChild(a);
                a.click();
                $window.setTimeout(function () {
                    URL.revokeObjectURL(fileURL);
                    a.parentNode.removeChild(a);
                });
            });
        }
    }
}]);



//////////////////
// WEBPACK FOOTER
// ./public/app/models/reviews_service.js
// module id = 864
// module chunks = 3